import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { useMetrics } from './useMetrics';
function useExportExcelResults(gameId: string) {
  const metrics = useMetrics();
  const { mutate: download, isLoading, isError, reset } = useMutation(
    () => BackendService.instance.game.exportExcelResults(gameId),
    {
      onSuccess: ({ url }) => {
        metrics.logEvent('Game.DownloadExcelResults', {
          gameId,
        });
        //Open the url in another tab to start downloading the file immediately
        window.open(url, '__blank');
      },
    },
  );

  return {
    download,
    isLoading,
    isErrorDownloading: isError,
    reset: reset,
  };
}

export default useExportExcelResults;
